{
  "pending": "Ausstehend"
}
